(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc22-duo-painpoints"] && !Shopify.designMode) return;
  try {
    
  function initLc22Painpoints(root) {
    if (root.dataset.lc22Ready === 'true') return;
    root.dataset.lc22Ready = 'true';
    const items = [...root.querySelectorAll('[data-lc22-painpoint]')];
    const visuals = [...root.querySelectorAll('[data-lc22-painpoint-visual]')];
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => { if (other !== item) other.open = false; });
        visuals.forEach((visual) => { visual.hidden = visual.dataset.lc22PainpointVisual !== item.dataset.lc22Painpoint; });
      });
    });
  }
  document.querySelectorAll('[data-lc22-painpoints]').forEach(initLc22Painpoints);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lc22-painpoints]').forEach(initLc22Painpoints);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc22-duo-reasons"] && !Shopify.designMode) return;
  try {
    
function lc22InitReviewCarousels(root) {
  root.querySelectorAll('[data-lc22-reviews]:not([data-lc22-ready])').forEach(function(carousel) {
    carousel.dataset.lc22Ready = 'true';
    var prev = carousel.querySelector('[data-lc22-prev]');
    var next = carousel.querySelector('[data-lc22-next]');
    var position = carousel.querySelector('[data-lc22-position]');
    var requestedMore = false;
    var pendingAdvance = false;
    var index = 0;
    function parts() {
      var track = carousel.querySelector('.jdgm-grid-body');
      return { track: track, cards: track ? Array.from(track.querySelectorAll(':scope > .jdgm-review-card')) : [] };
    }
    function refresh() {
      var view = parts();
      if (!view.track || !view.cards.length) { prev.disabled = true; next.disabled = true; return; }
      var step = view.cards[1] ? view.cards[1].offsetLeft - view.cards[0].offsetLeft : view.track.clientWidth;
      if (step > 0) index = Math.max(0, Math.min(view.cards.length - 1, Math.round(view.track.scrollLeft / step)));
      var total = parseInt(carousel.dataset.lc22ReviewTotal, 10) || view.cards.length;
      var label = 'Avis ' + (index + 1) + ' sur ' + total;
      if (position.textContent !== label) position.textContent = label;
      prev.disabled = index === 0;
      next.disabled = index >= total - 1;
      view.track.setAttribute('role', 'region');
      view.track.setAttribute('aria-label', 'Avis clients Judge.me');
      view.track.setAttribute('tabindex', '0');
    }
    function go(direction) {
      var view = parts();
      if (!view.cards.length) return;
      var target = Math.max(0, index + direction);
      if (target >= view.cards.length) {
        var more = carousel.querySelector('.jm-show-more-button');
        if (more && !requestedMore) { requestedMore = true; pendingAdvance = true; more.click(); }
        return;
      }
      index = target;
      view.track.scrollTo({ left: view.cards[index].offsetLeft - view.cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      position.textContent = 'Avis ' + (index + 1) + ' sur ' + (parseInt(carousel.dataset.lc22ReviewTotal, 10) || view.cards.length);
      prev.disabled = index === 0;
    }
    prev.addEventListener('click', function() { go(-1); });
    next.addEventListener('click', function() { go(1); });
    carousel.addEventListener('scroll', function(event) { if (event.target.classList.contains('jdgm-grid-body')) window.requestAnimationFrame(refresh); }, true);
    var app = carousel.querySelector('[data-widget="reviews-grid"]');
    if (app) new MutationObserver(function() {
      var view = parts();
      if (view.cards.length > index + 1) {
        requestedMore = false;
        if (pendingAdvance) { pendingAdvance = false; go(1); return; }
      }
      refresh();
    }).observe(app, { childList: true, subtree: true });
    refresh();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { lc22InitReviewCarousels(document); });
else lc22InitReviewCarousels(document);
document.addEventListener('shopify:section:load', function(event) { lc22InitReviewCarousels(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc22-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc22-review-carousel')) {
    customElements.define('lc22-review-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.lc22-reviews__track');
        const controls = this.querySelector('.lc22-reviews__controls');
        const previous = controls.querySelector('[data-direction="-1"]');
        const next = controls.querySelector('[data-direction="1"]');
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          controls.hidden = max <= 2;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        };
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          const card = track.querySelector('li');
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          track.scrollBy({ left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        track.addEventListener('scroll', update, { signal, passive: true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
